import { Collection, Model } from 'web-mojo';

class Route extends Model {
    constructor(data = {}) {
        super(data, {
            endpoint: '/api/routes/route'
        });
    }

    nameOrId() {
        const tmpl = this.get('template');
        return tmpl ? tmpl.name : `Route ${this.get('id')}`;
    }

    operatorName() {
        const op = this.get('operator');
        return op ? (op.display_name || op.user?.username || '') : 'Unassigned';
    }

    progressText() {
        const p = this.get('progress');
        if (!p) return '';
        return `${p.completed} / ${p.total}`;
    }

    progressPercent() {
        const p = this.get('progress');
        if (!p || !p.total) return 0;
        return Math.round((p.completed / p.total) * 100);
    }

    isInProgress() {
        return this.get('status') === 'in_progress';
    }

    isScheduled() {
        return this.get('status') === 'scheduled';
    }
}

class RouteList extends Collection {
    constructor(options = {}) {
        super({
            ModelClass: Route,
            endpoint: '/api/routes/route',
            ...options
        });
    }
}

export { Route, RouteList };
